<template>
  <div id="select-location">
    <img
      src="@/assets/icons/wilderverse.png"
      class="wilderverse"
    >
    <div class="flex">
      <p class="header">WHAT LANDMARK DO YOU SEE ON THE TREE?</p>
      <div class="locations">
        <div
          class="location"
          v-for="location in locations"
          :key="location.id"
        >
          <circle-select
            :option="{name: location.name, fillImage: location.icon}"
            @click.native="select(location)"
            :style="{ height: '20vw', width: '20vw', margin: 'auto' }"
          >
          </circle-select>
          <p>{{ location.name.toUpperCase() }}</p>
        </div>
      </div>
      <p class="notice">You can change your pathfinder's location later if you move</p>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import CircleSelect from "@/components/CircleSelect.vue";
  export default {
    components: { CircleSelect },
    computed: {
      ...mapState({
        pathfinder: state => state.pathfinders.pathfinder,
        locations: state => state.locations.locations
      })
    },
    methods: {
      ...mapActions(["spawnPathfinder"]),
      select(location) {
        this.spawnPathfinder(location).then(_ => {
          this.$router.push({ name: "dashboard" });
        });
      }
    }
  };
</script>

<style lang="scss">
  @import "@/assets/global.scss";

  #select-location {
    @include jungle-background;

    height: 100vh;
    @media only screen and (max-width: 320px) {
      height: initial;
    }
    padding: 1em;

    .wilderverse {
      width: 30%;
    }

    .flex {
      margin-top: 1em;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 75%;
      justify-content: space-between;
    }

    p {
      width: 80%;
      text-align: center;
    }

    p.header {
      font-weight: bold;
    }

    p.notice {
      font-size: 1em;
      font-weight: bold;
      color: $secondary;
    }

    button {
      width: 80%;
      height: 3em;
    }

    .locations {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .location {
        padding: 1em;
        p {
          margin: auto;
        }
      }
    }
  }
</style>
